import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  Paper,
  Box,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Autocomplete,
  Chip,
} from '@mui/material';
import { useStateValue } from '../../../contexto/store';
import { withRouter } from 'react-router-dom';
import { produce } from 'immer';
import { generate } from 'shortid';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ShareIcon from '@mui/icons-material/Share';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import CampaignIcon from '@mui/icons-material/Campaign';
import BusinessIcon from '@mui/icons-material/Business';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import NotesIcon from '@mui/icons-material/Notes';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BadgeIcon from '@mui/icons-material/Badge';
import {
  obtenerCiudades,
  obtenerBarrios,
  registrarCliente,
  obtenerClientePorCi,
} from '../../../actions/ClientesAction';
import { obtenerCampanas } from '../../../actions/CampanasAction';
import { RegistrarAccion } from '../../../actions/AuditoriaAction';
const ClienteNuevo = (props) => {
  const [barrioCiu, setBarrioCiu] = useState('');
  const [telefonos, setTelefonos] = useState([]);
  const [direcciones, setDirecciones] = useState([]);
  const [Datar, setDatar] = useState([]);
  const [DataCiu, setDataCiu] = useState([]);
  const [DataBa, setDataBa] = useState([]);
  const [campana, setCampana] = useState('');
  const [redes, setRedes] = useState([]);
  //eslint-disable-next-line
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [cliente, setCliente] = useState({
    NOMBRE: '',
    APELLIDO: '',
    CI: '',
    RUC: '',
    CAMPANA: '',
    PROFESIONORUBRO: '',
    HOBBY: '',
    OBSERVACIONES: '',
  });
  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setCliente((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };

  const selectCampanahandleChange = (event) => {
    setCampana(event.target.value);
  };
  const registrarClienteBoton = (e) => {
    e.preventDefault();
    let objetoClienteNuevo = {};
    if (
      telefonos[0] === undefined &&
      direcciones[0] === undefined &&
      redes[0] === undefined
    ) {
      objetoClienteNuevo = {
        NOMBRE: cliente.NOMBRE,
        APELLIDO: cliente.APELLIDO,
        CI: cliente.CI,
        RUC: cliente.RUC,
        CAMPANA_Id: campana,
        PROFESIONORUBRO: cliente.PROFESIONORUBRO,
        HOBBY: cliente.HOBBY,
        OBSERVACIONES: cliente.OBSERVACIONES,
      };
    } else if (
      telefonos[0] !== undefined &&
      direcciones[0] === undefined &&
      redes[0] === undefined
    ) {
      if (
        telefonos[0].DESCRITELEFONO !== '' ||
        telefonos[0].DETALLESTELEFONO !== ''
      ) {
        objetoClienteNuevo = {
          NOMBRE: cliente.NOMBRE,
          APELLIDO: cliente.APELLIDO,
          CI: cliente.CI,
          RUC: cliente.RUC,
          CAMPANA_Id: campana,
          TELEFONOS: telefonos,
          PROFESIONORUBRO: cliente.PROFESIONORUBRO,
          HOBBY: cliente.HOBBY,
          OBSERVACIONES: cliente.OBSERVACIONES,
        };
      } else {
        objetoClienteNuevo = {
          NOMBRE: cliente.NOMBRE,
          APELLIDO: cliente.APELLIDO,
          CI: cliente.CI,
          RUC: cliente.RUC,
          CAMPANA_Id: campana,
          PROFESIONORUBRO: cliente.PROFESIONORUBRO,
          HOBBY: cliente.HOBBY,
          OBSERVACIONES: cliente.OBSERVACIONES,
        };
      }
    } else if (
      telefonos[0] === undefined &&
      direcciones[0] !== undefined &&
      redes[0] === undefined
    ) {
      if (
        direcciones[0].DESCRIDIRECCION !== '' ||
        direcciones[0].DETALLESDIRECCION !== ''
      ) {
        objetoClienteNuevo = {
          NOMBRE: cliente.NOMBRE,
          APELLIDO: cliente.APELLIDO,
          CI: cliente.CI,
          RUC: cliente.RUC,
          CAMPANA_Id: campana,
          DIRECCIONES: direcciones,
          PROFESIONORUBRO: cliente.PROFESIONORUBRO,
          HOBBY: cliente.HOBBY,
          OBSERVACIONES: cliente.OBSERVACIONES,
        };
      } else {
        objetoClienteNuevo = {
          NOMBRE: cliente.NOMBRE,
          APELLIDO: cliente.APELLIDO,
          CI: cliente.CI,
          RUC: cliente.RUC,
          CAMPANA_Id: campana,
          PROFESIONORUBRO: cliente.PROFESIONORUBRO,
          HOBBY: cliente.HOBBY,
          OBSERVACIONES: cliente.OBSERVACIONES,
        };
      }
    } else if (
      telefonos[0] === undefined &&
      direcciones[0] !== undefined &&
      redes[0] !== undefined
    ) {
      if (
        (direcciones[0].DESCRIDIRECCION !== '' ||
          direcciones[0].DETALLESDIRECCION !== '') &&
        (redes[0].Nick === '' || redes[0].RedSocial === '')
      ) {
        objetoClienteNuevo = {
          NOMBRE: cliente.NOMBRE,
          APELLIDO: cliente.APELLIDO,
          CI: cliente.CI,
          RUC: cliente.RUC,
          CAMPANA_Id: campana,
          DIRECCIONES: direcciones,
          PROFESIONORUBRO: cliente.PROFESIONORUBRO,
          HOBBY: cliente.HOBBY,
          OBSERVACIONES: cliente.OBSERVACIONES,
        };
      } else if (
        (redes[0].Nick !== '' || redes[0].RedSocial !== '') &&
        (direcciones[0].DESCRIDIRECCION === '' ||
          direcciones[0].DETALLESDIRECCION === '')
      ) {
        objetoClienteNuevo = {
          NOMBRE: cliente.NOMBRE,
          APELLIDO: cliente.APELLIDO,
          CI: cliente.CI,
          RUC: cliente.RUC,
          CAMPANA_Id: campana,
          REDES: redes,
          PROFESIONORUBRO: cliente.PROFESIONORUBRO,
          HOBBY: cliente.HOBBY,
          OBSERVACIONES: cliente.OBSERVACIONES,
        };
      } else {
        objetoClienteNuevo = {
          NOMBRE: cliente.NOMBRE,
          APELLIDO: cliente.APELLIDO,
          CI: cliente.CI,
          RUC: cliente.RUC,
          CAMPANA_Id: campana,
          DIRECCIONES: direcciones,
          REDES: redes,
          PROFESIONORUBRO: cliente.PROFESIONORUBRO,
          HOBBY: cliente.HOBBY,
          OBSERVACIONES: cliente.OBSERVACIONES,
        };
      }
    } else if (
      telefonos[0] !== undefined &&
      direcciones[0] === undefined &&
      redes[0] !== undefined
    ) {
      if (
        (telefonos[0].DESCRITELEFONO !== '' ||
          telefonos[0].DETALLESTELEFONO !== '') &&
        (redes[0].Nick === '' || redes[0].RedSocial === '')
      ) {
        objetoClienteNuevo = {
          NOMBRE: cliente.NOMBRE,
          APELLIDO: cliente.APELLIDO,
          CI: cliente.CI,
          RUC: cliente.RUC,
          CAMPANA_Id: campana,
          TELEFONOS: telefonos,
          PROFESIONORUBRO: cliente.PROFESIONORUBRO,
          HOBBY: cliente.HOBBY,
          OBSERVACIONES: cliente.OBSERVACIONES,
        };
      } else if (
        (redes[0].Nick !== '' || redes[0].RedSocial !== '') &&
        (telefonos[0].DESCRITELEFONO === '' ||
          telefonos[0].DETALLESTELEFONO === '')
      ) {
        objetoClienteNuevo = {
          NOMBRE: cliente.NOMBRE,
          APELLIDO: cliente.APELLIDO,
          CI: cliente.CI,
          RUC: cliente.RUC,
          CAMPANA_Id: campana,
          REDES: redes,
          PROFESIONORUBRO: cliente.PROFESIONORUBRO,
          HOBBY: cliente.HOBBY,
          OBSERVACIONES: cliente.OBSERVACIONES,
        };
      } else {
        objetoClienteNuevo = {
          NOMBRE: cliente.NOMBRE,
          APELLIDO: cliente.APELLIDO,
          CI: cliente.CI,
          RUC: cliente.RUC,
          CAMPANA_Id: campana,
          TELEFONOS: telefonos,
          REDES: redes,
          PROFESIONORUBRO: cliente.PROFESIONORUBRO,
          HOBBY: cliente.HOBBY,
          OBSERVACIONES: cliente.OBSERVACIONES,
        };
      }
    } else if (
      telefonos[0] !== undefined &&
      direcciones[0] !== undefined &&
      redes[0] === undefined
    ) {
      if (
        (telefonos[0].DESCRITELEFONO !== '' ||
          telefonos[0].DETALLESTELEFONO !== '') &&
        (direcciones[0].DESCRIDIRECCION === '' ||
          direcciones[0].DETALLESDIRECCION === '')
      ) {
        objetoClienteNuevo = {
          NOMBRE: cliente.NOMBRE,
          APELLIDO: cliente.APELLIDO,
          CI: cliente.CI,
          RUC: cliente.RUC,
          CAMPANA_Id: campana,
          TELEFONOS: telefonos,
          PROFESIONORUBRO: cliente.PROFESIONORUBRO,
          HOBBY: cliente.HOBBY,
          OBSERVACIONES: cliente.OBSERVACIONES,
        };
      } else if (
        (direcciones[0].DESCRIDIRECCION !== '' ||
          direcciones[0].DETALLESDIRECCION !== '') &&
        (telefonos[0].DESCRITELEFONO === '' ||
          telefonos[0].DETALLESTELEFONO === '')
      ) {
        objetoClienteNuevo = {
          NOMBRE: cliente.NOMBRE,
          APELLIDO: cliente.APELLIDO,
          CI: cliente.CI,
          RUC: cliente.RUC,
          CAMPANA_Id: campana,
          DIRECCIONES: direcciones,
          PROFESIONORUBRO: cliente.PROFESIONORUBRO,
          HOBBY: cliente.HOBBY,
          OBSERVACIONES: cliente.OBSERVACIONES,
        };
      } else {
        objetoClienteNuevo = {
          NOMBRE: cliente.NOMBRE,
          APELLIDO: cliente.APELLIDO,
          CI: cliente.CI,
          RUC: cliente.RUC,
          CAMPANA_Id: campana,
          TELEFONOS: telefonos,
          DIRECCIONES: direcciones,
          PROFESIONORUBRO: cliente.PROFESIONORUBRO,
          HOBBY: cliente.HOBBY,
          OBSERVACIONES: cliente.OBSERVACIONES,
        };
      }
    } else if (
      telefonos[0] === undefined &&
      direcciones[0] === undefined &&
      redes[0] !== undefined
    ) {
      if (redes[0].Nick !== '' || redes[0].RedSocial !== '') {
        objetoClienteNuevo = {
          NOMBRE: cliente.NOMBRE,
          APELLIDO: cliente.APELLIDO,
          CI: cliente.CI,
          RUC: cliente.RUC,
          CAMPANA_Id: campana,
          REDES: redes,
          PROFESIONORUBRO: cliente.PROFESIONORUBRO,
          HOBBY: cliente.HOBBY,
          OBSERVACIONES: cliente.OBSERVACIONES,
        };
      } else {
        objetoClienteNuevo = {
          NOMBRE: cliente.NOMBRE,
          APELLIDO: cliente.APELLIDO,
          CI: cliente.CI,
          RUC: cliente.RUC,
          CAMPANA_Id: campana,
          PROFESIONORUBRO: cliente.PROFESIONORUBRO,
          HOBBY: cliente.HOBBY,
          OBSERVACIONES: cliente.OBSERVACIONES,
        };
      }
    } else {
      objetoClienteNuevo = {
        NOMBRE: cliente.NOMBRE,
        APELLIDO: cliente.APELLIDO,
        CI: cliente.CI,
        RUC: cliente.RUC,
        CAMPANA_Id: campana,
        TELEFONOS: telefonos,
        DIRECCIONES: direcciones,
        REDES: redes,
        PROFESIONORUBRO: cliente.PROFESIONORUBRO,
        HOBBY: cliente.HOBBY,
        OBSERVACIONES: cliente.OBSERVACIONES,
      };
    }
    obtenerClientePorCi(cliente.CI).then((response) => {
      if (response.data.length > 0) {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Ya existe un cliente con ese CI',
          },
        });
      } else {
        obtenerClientePorCi(cliente.RUC).then((response) => {
          if (response.data.length > 0) {
            dispatch({
              type: 'OPEN_SNACKBAR',
              openMensaje: {
                open: true,
                mensaje: 'Ya existe un cliente con ese RUC',
              },
            });
          } else {
            registrarCliente(objetoClienteNuevo).then((response) => {
              if (response.status === 200) {
                dispatch({
                  type: 'OPEN_SNACKBAR',
                  openMensaje: {
                    open: true,
                    mensaje: 'Se guardo exitosamente el Cliente',
                  },
                });
                let objetoAudi = {
                  usuario: sesionUsuario.usuario.nombrecompleto,
                  accion: 'Registro',
                  panel: 'Gestion de Clientes',
                  tabla: 'CLIENTES',
                  filaafectada: 'NUEVO REGISTRO',
                  UsuarioId: sesionUsuario.usuario.id,
                };
                RegistrarAccion(objetoAudi);
                props.history.goBack();
              } else {
                dispatch({
                  type: 'OPEN_SNACKBAR',
                  openMensaje: {
                    open: true,
                    mensaje:
                      'Errores al intentar guardar Asegurese de llenar todos los campos ',
                  },
                });
              }
            });
          }
        });
      }
    });
  };
  const volver = () => {
    props.history.goBack();
  };
  useEffect(() => {
    obtenerCiudades().then((response) => {
      const Data = response.data;
      setDataCiu(Data);
    });
    if (barrioCiu !== '') {
      obtenerBarrios(barrioCiu).then((response) => {
        const Data = response.data;
        setDataBa(Data);
      });
    }
    obtenerCampanas().then((response) => {
      const Data = response.data;
      setDatar(Data);
    });
  }, [barrioCiu, sesionUsuario]);

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      {/* Header moderno */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
            }}
          >
            <PersonAddIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ color: 'white', fontWeight: 600, mb: 0.5 }}>
              Nuevo Cliente
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
              Complete el formulario para registrar un nuevo cliente
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Formulario principal */}
      <Paper elevation={0} sx={{ p: 4, mb: 3, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
          <BadgeIcon sx={{ color: 'primary.main' }} />
          <Typography variant="h6" fontWeight={600}>
            Información Básica
          </Typography>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              name="NOMBRE"
              value={cliente.NOMBRE}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Nombre"
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="APELLIDO"
              value={cliente.APELLIDO}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Apellido / Razón Social"
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="CI"
              value={cliente.CI}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Nro. Cédula"
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="RUC"
              value={cliente.RUC}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="RUC"
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="PROFESIONORUBRO"
              value={cliente.PROFESIONORUBRO}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Profesión / Rubro"
              InputProps={{
                startAdornment: <BusinessIcon sx={{ mr: 1, color: 'text.secondary' }} />,
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="HOBBY"
              value={cliente.HOBBY}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Hobby / Intereses"
              InputProps={{
                startAdornment: <SportsEsportsIcon sx={{ mr: 1, color: 'text.secondary' }} />,
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl fullWidth variant="outlined">
              <InputLabel>Campaña</InputLabel>
              <Select
                value={campana}
                onChange={selectCampanahandleChange}
                label="Campaña"
                startAdornment={<CampaignIcon sx={{ ml: 1, mr: 0.5, color: 'text.secondary' }} />}
              >
                {Datar.map((campana) => (
                  <MenuItem key={campana.campanA_Id} value={campana.campanA_Id}>
                    {campana.descricampana}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="OBSERVACIONES"
              value={cliente.OBSERVACIONES}
              onChange={ingresarValoresMemoria}
              variant="outlined"
              fullWidth
              multiline
              rows={3}
              label="Observaciones"
              placeholder="Notas adicionales sobre el cliente..."
              InputProps={{
                startAdornment: <NotesIcon sx={{ mr: 1, mt: 1, color: 'text.secondary', alignSelf: 'flex-start' }} />,
              }}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Accordion de Teléfonos */}
      <Accordion 
        elevation={0} 
        sx={{ 
          mb: 2, 
          border: '1px solid', 
          borderColor: 'divider',
          borderRadius: 2,
          '&:before': { display: 'none' },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            backgroundColor: 'action.hover',
            borderRadius: 2,
            '&:hover': {
              backgroundColor: 'action.selected',
            },
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
            <PhoneIcon sx={{ color: 'primary.main' }} />
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h6" fontWeight={600}>
                Teléfonos
              </Typography>
              {telefonos.length > 0 && (
                <Typography variant="caption" color="text.secondary">
                  {telefonos.length} teléfono{telefonos.length !== 1 ? 's' : ''} agregado{telefonos.length !== 1 ? 's' : ''}
                </Typography>
              )}
            </Box>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddCircleOutlineIcon />}
              onClick={(e) => {
                e.stopPropagation();
                setTelefonos((telefonoActual) => [
                  ...telefonoActual,
                  {
                    CODTELEFONO: generate(),
                    DESCRITELEFONO: '',
                    DETALLESTELEFONO: '',
                  },
                ]);
              }}
              sx={{ borderRadius: 2 }}
            >
              Agregar
            </Button>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ mt: 2 }}>
            {telefonos.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 4, color: 'text.secondary' }}>
                <PhoneIcon sx={{ fontSize: 48, opacity: 0.3, mb: 1 }} />
                <Typography variant="body2">
                  No hay teléfonos agregados. Haga clic en "Agregar" para añadir uno.
                </Typography>
              </Box>
            ) : (
              <Grid container spacing={2}>
                {telefonos.map((t, index) => (
                  <Grid item xs={12} key={t.CODTELEFONO}>
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        '&:hover': {
                          boxShadow: 2,
                        },
                        transition: 'box-shadow 0.2s ease',
                      }}
                    >
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={5}>
                          <TextField
                            name="TELEFONO"
                            value={t.DESCRITELEFONO}
                            onChange={(e) => {
                              const DESCRITELEFONO = e.target.value;
                              setTelefonos((telefonoActual) =>
                                produce(telefonoActual, (v) => {
                                  v[index].DESCRITELEFONO = DESCRITELEFONO;
                                })
                              );
                            }}
                            variant="outlined"
                            label="Número de Teléfono"
                            fullWidth
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            name="DETALLESTELEFONO"
                            value={t.DETALLESTELEFONO}
                            onChange={(e) => {
                              const DETALLESTELEFONO = e.target.value;
                              setTelefonos((telefonoActual) =>
                                produce(telefonoActual, (v) => {
                                  v[index].DETALLESTELEFONO = DETALLESTELEFONO;
                                })
                              );
                            }}
                            variant="outlined"
                            label="Detalles (ej: Celular personal, Oficina...)"
                            fullWidth
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={12} sm={1} sx={{ textAlign: 'center' }}>
                          <IconButton
                            color="error"
                            onClick={() => {
                              setTelefonos((telefonoActual) =>
                                telefonoActual.filter((x) => x.CODTELEFONO !== t.CODTELEFONO)
                              );
                            }}
                            sx={{
                              '&:hover': {
                                backgroundColor: 'error.light',
                                color: 'white',
                              },
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>
        </AccordionDetails>
      </Accordion>

      {/* Accordion de Direcciones */}
      <Accordion 
        elevation={0} 
        sx={{ 
          mb: 2, 
          border: '1px solid', 
          borderColor: 'divider',
          borderRadius: 2,
          '&:before': { display: 'none' },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            backgroundColor: 'action.hover',
            borderRadius: 2,
            '&:hover': {
              backgroundColor: 'action.selected',
            },
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
            <LocationOnIcon sx={{ color: 'primary.main' }} />
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h6" fontWeight={600}>
                Direcciones
              </Typography>
              {direcciones.length > 0 && (
                <Typography variant="caption" color="text.secondary">
                  {direcciones.length} dirección{direcciones.length !== 1 ? 'es' : ''} agregada{direcciones.length !== 1 ? 's' : ''}
                </Typography>
              )}
            </Box>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddCircleOutlineIcon />}
              onClick={(e) => {
                e.stopPropagation();
                setDirecciones((direccionActual) => [
                  ...direccionActual,
                  {
                    CODDIRECCION: generate(),
                    DETALLESDIRECCION: '',
                    DESCRIDIRECCION: '',
                    CIUDAD: { CIUDAD_Id: '' },
                    BARRIO: { BARRIO_Id: '' },
                  },
                ]);
              }}
              sx={{ borderRadius: 2 }}
            >
              Agregar
            </Button>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ mt: 2 }}>
            {direcciones.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 4, color: 'text.secondary' }}>
                <LocationOnIcon sx={{ fontSize: 48, opacity: 0.3, mb: 1 }} />
                <Typography variant="body2">
                  No hay direcciones agregadas. Haga clic en "Agregar" para añadir una.
                </Typography>
              </Box>
            ) : (
              <Grid container spacing={3}>
                {direcciones.map((d, index) => (
                  <Grid item xs={12} key={d.CODDIRECCION}>
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 3,
                        borderRadius: 2,
                        '&:hover': {
                          boxShadow: 2,
                        },
                        transition: 'box-shadow 0.2s ease',
                      }}
                    >
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                        <Chip
                          label={`Dirección ${index + 1}`}
                          color="primary"
                          variant="outlined"
                          size="small"
                        />
                        <IconButton
                          color="error"
                          size="small"
                          onClick={() => {
                            setDirecciones((direccionActual) =>
                              direccionActual.filter((x) => x.CODDIRECCION !== d.CODDIRECCION)
                            );
                          }}
                          sx={{
                            '&:hover': {
                              backgroundColor: 'error.light',
                              color: 'white',
                            },
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>

                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            name="DIRECCION"
                            value={d.DESCRIDIRECCION}
                            onChange={(e) => {
                              const DESCRIDIRECCION = e.target.value;
                              setDirecciones((direccionActual) =>
                                produce(direccionActual, (v) => {
                                  v[index].DESCRIDIRECCION = DESCRIDIRECCION;
                                })
                              );
                            }}
                            variant="outlined"
                            label="Dirección"
                            fullWidth
                            multiline
                            rows={2}
                            placeholder="Calle, número, referencias..."
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            name="DETALLESDIRECCION"
                            value={d.DETALLESDIRECCION}
                            onChange={(e) => {
                              const DETALLESDIRECCION = e.target.value;
                              setDirecciones((direccionActual) =>
                                produce(direccionActual, (v) => {
                                  v[index].DETALLESDIRECCION = DETALLESDIRECCION;
                                })
                              );
                            }}
                            variant="outlined"
                            label="Detalles adicionales"
                            fullWidth
                            placeholder="Casa, apartamento, entre calles..."
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Autocomplete
                            options={DataCiu}
                            getOptionLabel={(option) => option.descriciudad || ''}
                            isOptionEqualToOption={(option, value) =>
                              option.ciudaD_Id === value.ciudaD_Id
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Ciudad"
                                variant="outlined"
                                placeholder="Buscar ciudad..."
                              />
                            )}
                            onChange={(e, value) => {
                              if (value) {
                                setDirecciones((direccionActual) =>
                                  produce(direccionActual, (v) => {
                                    v[index].CIUDAD.CIUDAD_Id = value.ciudaD_Id;
                                  })
                                );
                                setBarrioCiu(value.ciudaD_Id);
                              }
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Autocomplete
                            options={DataBa}
                            getOptionLabel={(option) => option.describarrio || ''}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Barrio"
                                variant="outlined"
                                placeholder="Buscar barrio..."
                              />
                            )}
                            onChange={(e, value) => {
                              if (value) {
                                setDirecciones((direccionActual) =>
                                  produce(direccionActual, (v) => {
                                    v[index].BARRIO.BARRIO_Id = value.barriO_Id;
                                  })
                                );
                              }
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>
        </AccordionDetails>
      </Accordion>

      {/* Accordion de Redes Sociales */}
      <Accordion 
        elevation={0} 
        sx={{ 
          mb: 3, 
          border: '1px solid', 
          borderColor: 'divider',
          borderRadius: 2,
          '&:before': { display: 'none' },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            backgroundColor: 'action.hover',
            borderRadius: 2,
            '&:hover': {
              backgroundColor: 'action.selected',
            },
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
            <ShareIcon sx={{ color: 'primary.main' }} />
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h6" fontWeight={600}>
                Redes Sociales
              </Typography>
              {redes.length > 0 && (
                <Typography variant="caption" color="text.secondary">
                  {redes.length} red{redes.length !== 1 ? 'es' : ''} social{redes.length !== 1 ? 'es' : ''} agregada{redes.length !== 1 ? 's' : ''}
                </Typography>
              )}
            </Box>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddCircleOutlineIcon />}
              onClick={(e) => {
                e.stopPropagation();
                setRedes((redActual) => [
                  ...redActual,
                  {
                    CODRED: generate(),
                    Nick: '',
                    RedSocial: '',
                  },
                ]);
              }}
              sx={{ borderRadius: 2 }}
            >
              Agregar
            </Button>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ mt: 2 }}>
            {redes.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 4, color: 'text.secondary' }}>
                <ShareIcon sx={{ fontSize: 48, opacity: 0.3, mb: 1 }} />
                <Typography variant="body2">
                  No hay redes sociales agregadas. Haga clic en "Agregar" para añadir una.
                </Typography>
              </Box>
            ) : (
              <Grid container spacing={2}>
                {redes.map((t, index) => (
                  <Grid item xs={12} key={t.CODRED}>
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        '&:hover': {
                          boxShadow: 2,
                        },
                        transition: 'box-shadow 0.2s ease',
                      }}
                    >
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={5}>
                          <TextField
                            name="RedSocial"
                            value={t.RedSocial}
                            onChange={(e) => {
                              const RedSocial = e.target.value;
                              setRedes((redActual) =>
                                produce(redActual, (v) => {
                                  v[index].RedSocial = RedSocial;
                                })
                              );
                            }}
                            variant="outlined"
                            label="Red Social"
                            fullWidth
                            size="small"
                            placeholder="Facebook, Instagram, LinkedIn..."
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            name="Nick"
                            value={t.Nick}
                            onChange={(e) => {
                              const Nick = e.target.value;
                              setRedes((redActual) =>
                                produce(redActual, (v) => {
                                  v[index].Nick = Nick;
                                })
                              );
                            }}
                            variant="outlined"
                            label="Nombre de usuario"
                            fullWidth
                            size="small"
                            placeholder="@usuario"
                          />
                        </Grid>
                        <Grid item xs={12} sm={1} sx={{ textAlign: 'center' }}>
                          <IconButton
                            color="error"
                            onClick={() => {
                              setRedes((redActual) =>
                                redActual.filter((x) => x.CODRED !== t.CODRED)
                              );
                            }}
                            sx={{
                              '&:hover': {
                                backgroundColor: 'error.light',
                                color: 'white',
                              },
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>
        </AccordionDetails>
      </Accordion>

      {/* Botones de acción */}
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="outlined"
          size="large"
          startIcon={<ArrowBackIcon />}
          onClick={volver}
          sx={{
            borderRadius: 2,
            px: 4,
            fontWeight: 600,
          }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          size="large"
          startIcon={<SaveIcon />}
          onClick={registrarClienteBoton}
          sx={{
            borderRadius: 2,
            px: 4,
            fontWeight: 600,
            boxShadow: 3,
            '&:hover': {
              boxShadow: 6,
            },
          }}
        >
          Registrar Cliente
        </Button>
      </Box>
    </Container>
  );
};

export default withRouter(ClienteNuevo);
